import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import FieldList from "components/common/FieldList";
import Header from "components/common/Header";
import { IStore } from "interfaces/store";
import useAlert from "hooks/useAlert";
import useToken from "hooks/useToken";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import CobraStoreServices from "services/cobraStore";

const StoreDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { token } = useToken();
  const { onAlert } = useAlert();

  const [store, setStore] = useState<IStore | null>(null);

  useEffect(() => {
    const fetchData = () => {
      CobraStoreServices.getDetail(
        token as string,
        id as string
      )
        .then((res) => {
          setStore(res.data.data);
        })
        .catch((err) => {
          onAlert("error", err.response.data.message);
        });
    };

    fetchData();
  }, [id, token, onAlert]);

  if (store) {
    return (
      <>
        <Header
          title="Store Details"
          breadcrumbs={[
            {
              label: "Dashboard",
              href: `/dashboard`,
            },
            {
              label: "Cobra",
              href: `/dashboard/cobra`,
            },
            {
              label: "Store",
              href: `/store/cobra/list`,
            },
            {
              label: store.name,
            },
          ]}
        />
        <FieldList
          type="detail"
          fields={[
            {
              label: "Name",
              type: "text",
              name: "name",
              defaultValue: store.name,
              col: 6,
            },
            {
              label: "",
              type: "box",
              name: "",
              col: 6,
            },
            {
              label: "Latitude",
              type: "number",
              name: "lat",
              defaultValue: store.lat,
              col: 6,
            },
            {
              label: "Logitude",
              type: "number",
              name: "lng",
              defaultValue: store.lng,
              col: 6,
            },
            {
              label: "Address",
              type: "text",
              name: "address",
              defaultValue: store.address,
              col: 6,
            },
            {
              label: "Store Phone Number",
              type: "text",
              name: "tel",
              defaultValue: store.tel,
              col: 6,
            },
            {
              label: "Map URL",
              type: "text",
              name: "url",
              defaultValue: store.url,
              col: 6,
            },
          ]}
          onBack={() => navigate(`/store/cobra/list`)}
        />
      </>
    );
  } else {
    return <></>;
  }
};

export default withAuth(withPermission(StoreDetail, "MANAGE_COBRA"));
